import React from 'react';
import CTSUErrorBoundary from 'components/ErrorBoundary';

function RenderElement({ children, access }) {
  if (access === true) {
    return <CTSUErrorBoundary>{children}</CTSUErrorBoundary>;
  }
  return null;
}

export default RenderElement;
